import { create } from 'zustand';

const useStore = create((set) => ({
    loggedInUser: null,
    selectedCompany: null,
    accessToken: null,
    bootstrapped: false,
    setLoggedInUser: (user) => set({ loggedInUser: user }),
    setSelectedCompany: (company) => set({ selectedCompany: company }),
    setAccessToken: (token) => set({ accessToken: token }),
    setBootstrapped: (val) => set({ bootstrapped: val })
}));

export default useStore;